import showVideoResponse from 'helper/uppy/videoUploader';

window.fs_filepicker = window.filestack && window.filestack.init('AuG7ZQSxaSemtziJGYwbsz');

const executeHelper = useFilestackFilePicker => {
  window.$R.add('plugin', 'filepicker', {
    init(app) {
      this.app = app;

      // define services
      this.lang = app.lang;
      this.toolbar = app.toolbar;
    },
    start() {
      const buttonData = {
        title: 'File picker',
        api: 'plugin.filepicker.show',
        icon: '<i class="re-icon-image"></i>'
      };

      // create the button
      this.toolbar.addButton('filepicker', buttonData);
    },
    show() {
      if (useFilestackFilePicker) {
        window.fs_filepicker
          .picker({
            fromSources: [
              'local_file_system',
              'url',
              'imagesearch',
              'facebook',
              'instagram',
              'googledrive',
              'dropbox',
              'github',
              'gmail',
              'webcam',
              'video',
              'audio'
            ],
            accept: ['image/*'],
            maxFiles: 1,
            minFiles: 1,
            onFileUploadFinished: data => {
              this._insert(data);
            }
          })
          .open();
      } else {
        showVideoResponse('File picker', data => this._insert(data), 'picture-upload');
      }
      this.app.selection.save();
    },
    _insert(object) {
      this.app.selection.restore();
      // console.log('obj:: ', object);
      const html =
        '<figure class="redactor-component" data-redactor-type="image" tabindex="-1" contenteditable="false"><img src="' +
        object.url +
        '" data-image="8523ff27fe9906336aaef74d30cdd794"></figure>';
      // this.app.insertion.insertHtml(html);
      console.log(html);
      this.app.insertion.insertHtml(html);
      // this.code.sync();
    }
  });
  /*
    $j.Redactor.prototype.filepicker = function filepicker() {
      return {
        init() {
          const button = this.button.add('filepicker', 'Add Image');
          this.button.setIcon(button, '<i class="re-icon-image"></i>');
          this.button.addCallback(button, this.filepicker.show);
        },
        show() {
          fs_filepicker.pick({
            fromSources: ['local_file_system', 'url', 'imagesearch', 'facebook', 'instagram', 'googledrive', 'dropbox', 'evernote', 'flickr', 'github', 'gmail', 'webcam', 'video', 'audio'],
            accept: ['image/*'],
            maxFiles: 1,
            minFiles: 1
          }).then((r) => {
            this.filepicker.insert(r);
          });
          this.selection.save();
        },
        insert(object) {
          this.selection.restore();
          // console.log('obj:: ', object);
          const html = "<img src='" + object.filesUploaded[0].url + "' class='img-responsive'>"
          // this.app.insertion.insertHtml(html);
          this.insert.html(html);

          // this.code.sync();

        }
      };
    }; */
};

export default executeHelper;
